import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/release-notes")({
  beforeLoad: () => {
    throw redirect({ to: "/changelog", replace: true });
  },
});
